import './styles/main.scss';
import { escapeHtml } from './utils/dom';

let countdown = 30;

function timeAgo(dateStr: string | null): string {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    
    if (seconds < 60) return `${seconds}s ago`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    return `${Math.floor(seconds / 86400)}d ago`;
}

function formatDuration(start: string | null, end: string | null): string {
    if (!start) return '-';
    const startDate = new Date(start);
    const endDate = end ? new Date(end) : new Date();
    const seconds = Math.floor((endDate.getTime() - startDate.getTime()) / 1000);
    
    if (seconds < 60) return `${seconds}s`;
    if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
}

async function loadHistory(): Promise<void> {
    try {
        const response = await fetch('/api/history');
        const data = await response.json();
        
        // Update stats
        const statTotal = document.getElementById('stat-total');
        const statCompleted = document.getElementById('stat-completed');
        const statProcessing = document.getElementById('stat-processing');
        const statFailed = document.getElementById('stat-failed');

        if (statTotal) statTotal.textContent = data.stats.total;
        if (statCompleted) statCompleted.textContent = data.stats.completed;
        if (statProcessing) statProcessing.textContent = data.stats.processing;
        if (statFailed) statFailed.textContent = data.stats.failed;
        
        // Update table
        const tbody = document.getElementById('history-body');
        if (!tbody) return;
        
        if (data.onderleggers.length === 0) {
            tbody.innerHTML = '<tr><td colspan="7" class="empty-state">No onderleggers generated yet</td></tr>';
            return;
        }
        
        // Clear table and build rows safely
        tbody.innerHTML = '';
        
        data.onderleggers.forEach((o: any) => {
            const row = document.createElement('tr');
            
            // Status badge
            const statusCell = document.createElement('td');
            const statusBadge = document.createElement('span');
            statusBadge.className = `status-badge status-${o.status}`;
            statusBadge.textContent = o.status;
            statusCell.appendChild(statusBadge);
            row.appendChild(statusCell);
            
            // Location info
            const locationCell = document.createElement('td');
            const locationStrong = document.createElement('strong');
            locationStrong.textContent = o.location_name || 'Unknown';
            locationCell.appendChild(locationStrong);
            locationCell.appendChild(document.createElement('br'));
            
            const coordsSpan = document.createElement('span');
            coordsSpan.className = 'time-ago';
            coordsSpan.textContent = `${o.latitude?.toFixed(4)}, ${o.longitude?.toFixed(4)}`;
            locationCell.appendChild(coordsSpan);
            
            // Add error message if present (safely)
            if (o.error_message) {
                const errorDiv = document.createElement('div');
                errorDiv.className = 'history-error';
                errorDiv.title = o.error_message; // Browser handles title escaping
                errorDiv.textContent = `Error: ${o.error_message.substring(0, 30)}...`;
                locationCell.appendChild(errorDiv);
            }
            row.appendChild(locationCell);
            
            // Radius
            const radiusCell = document.createElement('td');
            radiusCell.textContent = `${o.radius}m`;
            row.appendChild(radiusCell);
            
            // Progress
            const progressCell = document.createElement('td');
            progressCell.textContent = `${o.progress}%`;
            row.appendChild(progressCell);
            
            // Created at
            const createdCell = document.createElement('td');
            const createdSpan = document.createElement('span');
            createdSpan.className = 'time-ago';
            createdSpan.textContent = timeAgo(o.created_at);
            createdCell.appendChild(createdSpan);
            row.appendChild(createdCell);
            
            // Duration
            const durationCell = document.createElement('td');
            durationCell.textContent = formatDuration(o.started_at, o.completed_at);
            row.appendChild(durationCell);
            
            // Actions
            const actionsCell = document.createElement('td');
            actionsCell.className = 'actions';
            
            if (o.status === 'completed' && o.has_files) {
                const viewLink = document.createElement('a');
                viewLink.href = `/view/${o.id}`;
                viewLink.textContent = 'Bekijk';
                actionsCell.appendChild(viewLink);
                
                const downloadLink = document.createElement('a');
                downloadLink.href = `/api/onderleggers/${o.id}/download`;
                downloadLink.textContent = 'Download';
                actionsCell.appendChild(downloadLink);
            } else if (o.status === 'completed') {
                const noFilesSpan = document.createElement('span');
                noFilesSpan.className = 'no-files-hint';
                noFilesSpan.title = 'Bestanden niet gevonden op deze server';
                noFilesSpan.textContent = 'Geen bestanden';
                actionsCell.appendChild(noFilesSpan);
            }
            row.appendChild(actionsCell);
            
            tbody.appendChild(row);
        });
        
    } catch (error) {
        console.error('Failed to load history:', error);
        const tbody = document.getElementById('history-body');
        if (tbody) {
            tbody.innerHTML = '<tr><td colspan="7" class="empty-state">Failed to load history</td></tr>';
        }
    }
    
    countdown = 30;
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    loadHistory();
    
    const refreshBtn = document.querySelector('.refresh-btn');
    refreshBtn?.addEventListener('click', () => loadHistory());

    // Auto-refresh countdown
    setInterval(() => {
        countdown--;
        const countdownEl = document.getElementById('countdown');
        if (countdownEl) countdownEl.textContent = countdown.toString();
        
        if (countdown <= 0) {
            loadHistory();
        }
    }, 1000);
});
